import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient global do app (Sprint 06 — D2 do briefing).
 *
 * - `staleTime: 30s` — dados ficam frescos por meio minuto antes de
 *   refetch automático (evita rajadas em navegação rápida entre páginas).
 * - `refetchOnWindowFocus: false` — UX corporativa, não rede social. O
 *   usuário invalida explicitamente via mutações.
 * - `retry: 1` — tentativas extras só uma; falha rápida em 401/403/404
 *   (interceptor do axios já trata refresh; quando falha, queremos saber).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
